import * as React from "react";
import { CloudLogo } from "@/assets/cloudLogo";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";

import { paths } from "@/paths";
import { RouterLink } from "@/components/core/link";

import { PlainNavbar } from "./navbar";

export function Hero(): React.JSX.Element {
	const theme = useTheme();
	return (
		<Box
			sx={{
				minHeight: "100vh",
				display: "flex",
				flexDirection: "column",
				backgroundColor: "#fff",
			}}
		>
			<PlainNavbar />
			{/* HERO CONTENT */}
			<Box
				sx={{
					height: "100%",
					backgroundColor: theme.palette.common.white,
					minHeight: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					textAlign: "center",
					px: 2,
					overflow: "hidden",
					flex: 1,
					transition: "margin-left 0.3s ease",
				}}
			>
				<Stack spacing={1.5} alignItems="center" justifyContent="center">
					<CloudLogo width={200} height={200} color="#659ed5" />

					<Typography
						variant="h4"
						color="#639ed6"
						sx={{
							fontWeight: 600,
							letterSpacing: ".02em",
							wordBreak: "break-word",
							whiteSpace: "normal",
							maxWidth: "100%",
						}}
					>
						{t("common:welcome")}
					</Typography>
					<Typography
						variant="h4"
						color="#639ed6"
						sx={{
							wordBreak: "break-word",
							whiteSpace: "normal",
							maxWidth: "100%",
						}}
					>
						{t("common:definition")}
					</Typography>
					<Button
						component={RouterLink}
						href={paths.dashboard.overview}
						disableElevation
						sx={{
							height: "50px",
							width: "200px",
							fontSize: "12px",
							borderRadius: "3px",
							fontWeight: 600,
							lineHeight: "24px",
							borderStyle: "solid",
							textAlign: "center",
							cursor: "pointer",
							textTransform: "uppercase",
							transition: ".33s all ease",
							letterSpacing: ".06em",
							m: 4,
							backgroundColor: "#659ed5",
							color: "var(--mui-palette-common-white)",
							"&:hover": {
								backgroundColor: "#ee7402",
								borderColor: "#ee7402",
							},
						}}
					>
						{t("common:toDashboard")}
					</Button>
				</Stack>
			</Box>
		</Box>
	);
}
